module.exports = __webpack_public_path__ + "img/登基·桌子上的开国大典.7430b0c7.png";